import { call, put, takeLatest } from "redux-saga/effects";
import * as apis from "../../network/apis/vouchers";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";

function* voucherRequestsListSaga({ payload }) {
  try {
    const response = yield call(apis.getVoucherRequestsList, payload);
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.getVoucherRequestsListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.getVoucherRequestsListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* vouchersUsedNotUsedListSaga({ payload }) {
  try {
    const response = yield call(
      apis.getVouchersUsedNotUsedList,
      payload
    );
    const { Items, CurrentPage, ItemCount, TotalPages } =
      response.data.Data;
    yield put(
      actions.getVouchersUsedNotUsedListResponse({
        list: Items,
        meta: {
          currentPage: +CurrentPage,
          count: +ItemCount,
          pages: +TotalPages
        }
      })
    );
    if (CurrentPage && TotalPages && +CurrentPage > +TotalPages) {
      yield put(
        actions.getVouchersUsedNotUsedListRequest({
          ...payload,
          page: +TotalPages
        })
      );
    }
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

function* generateVoucherRequestSaga({ payload }) {
  const { data, params, tabValue } = payload;
  try {
    const response = yield call(apis.generateVoucher, data);
    yield put(
      tabValue === 0
        ? actions.getVoucherRequestsListRequest({
            params
          })
        : actions.getVouchersUsedNotUsedListRequest({
            params
          })
    );
    showSuccessMsg("", response.data.Data.Message);
  } catch (error) {
    yield error.response?.data?.Message &&
      showErrorMsg(error.response?.data?.Message);
  }
}

export default function* VouchersSagas() {
  yield takeLatest(
    types.GET_VOUCHER_REQUESTS_LIST_REQUEST,
    voucherRequestsListSaga
  );
  yield takeLatest(
    types.GET_VOUCHERS_USED_NOT_USED_LIST_REQUEST,
    vouchersUsedNotUsedListSaga
  );
  yield takeLatest(
    types.GENERATE_VOUCHER_REQUEST,
    generateVoucherRequestSaga
  );
}
